import React, { useContext, useEffect, useLayoutEffect, useState } from 'react';

import * as S from './styles';
import TitleNavBarContext from 'context/TitleNavBarContext';
import LoadGeneralContext from 'context/LoadGeneralContext';
import SystemNotifyContext from 'context/SystemNotifyContext';
import { useTranslation } from 'react-i18next';
import { UseTranslationProps } from 'types/UseTranslationProps';
import AddBtn from 'components/AddBtn';
import ListLogos from 'components/ListLogos';
import FormLogo from 'components/FormLogo';
import { LogoProps } from 'types/LogoProps';
import { getLogos, deleteLogoReq } from './reqs';
import Load from 'components/Load';

export default function Logos() {
	const { i18n }: UseTranslationProps = useTranslation();
	const { handleNotify } = useContext(SystemNotifyContext);
	const { setDataAbouTitle } = useContext(TitleNavBarContext);
	const { setIsOpenLoad, setMessage } = useContext(LoadGeneralContext);

	const [isLoad, setIsLoad] = useState(false);
	const [isFormOpen, setIsFormOpen] = useState(false);
	const [listLogos, setListLogos] = useState<LogoProps[]>([]);
	const [logoToEdit, setLogoToEdit] = useState<LogoProps | null>(null);

	function getLogoToEdit(logo: LogoProps) {
		setLogoToEdit(logo);
		setIsFormOpen(true);
	}

	async function deleteLogo(logo: LogoProps) {
		setIsOpenLoad(true);
		setMessage('Deletando logo...');

		const { isSuccess } = await deleteLogoReq(logo.id, handleNotify);

		if (isSuccess) {
			const newList = listLogos.filter((item) => item.id !== logo.id);
			setListLogos(newList);
		}

		setIsOpenLoad(false);

		return isSuccess;
	}

	//busca lista de logos
	useEffect(() => {
		(async () => {
			const { isSuccess, list } = await getLogos(setIsLoad, handleNotify);
			if (isSuccess) {
				setListLogos(list);
			}
		})();
	}, []);

	//muda titulo do componente
	useLayoutEffect(() => {
		setDataAbouTitle((value) => ({ ...value, title: 'Lista de logos' }));
	}, [i18n?.language]);

	return (
		<S.container>
			<AddBtn
				anyFunction={() => {
					setIsFormOpen(true);
				}}
				text="Adicionar logo"
			/>
			{isLoad ? (
				<S.centralize>
					<Load showText text="Buscando logos" />
				</S.centralize>
			) : (
				<ListLogos
					list={listLogos}
					getLogoToEdit={getLogoToEdit}
					deleteLogo={deleteLogo}
				/>
			)}

			{isFormOpen && (
				<FormLogo
					isOpenForm={isFormOpen}
					setIsOpenForm={setIsFormOpen}
					logoToEdit={logoToEdit}
					setLogoToEdit={setLogoToEdit}
					setListLogos={setListLogos}
					listLogos={listLogos}
				/>
			)}
		</S.container>
	);
}
